export default "__VITE_ASSET__LOUJgQl2__"